import React from "react";

import defaultStyle from "./DragLabel.module.scss";
import { DragLabel as CoreDragLabel } from "@jelly/lesson";

export const DragLabel: React.FC<React.ComponentProps<typeof CoreDragLabel>> = (props) => {
  return <CoreDragLabel {...props} style={defaultStyle} />;
};
